import { null as zNull } from "zod";

export const disconnectLuminousIntegration = {
  name: "disconnectLuminousIntegration" as const,
  input: zNull(),
  output: zNull(),
};
